import { useMemo } from 'react';
import { getPreviewComponents } from '../preview_component_mapping';
const NullComponent = () => null;
export const usePreviewComponent = (previewOptions, productVersion = '', fallback = NullComponent) => {
    const previewId = previewOptions === null || previewOptions === void 0 ? void 0 : previewOptions.id;
    return useMemo(() => {
        var _a;
        if (!previewId) {
            return fallback;
        }
        const previewComponents = getPreviewComponents(productVersion);
        return (_a = previewComponents[previewId]) !== null && _a !== void 0 ? _a : fallback;
    }, [previewId, productVersion, fallback]);
};
//# sourceMappingURL=use_preview_component.js.map